import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ViewVehicleDetailsService {

  constructor(private http:HttpClient) { }

  getVehicleById(data:any){
    return this.http.post(environment.apiUrl + "vehicles/get/byId" , data)
  }


}
